import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-ticker-nav',
  templateUrl: './ticker-nav.component.html',
  styleUrls: ['./ticker-nav.component.scss']
})
export class TickerNavComponent implements OnInit {

  @Output() goto = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  emitNav(route){
    this.goto.emit(route);
  }

}
